<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Консьержи</strong>
                </CCardHeader>
                <CCardBody>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <template v-else>
                        <div class="flex mt-2">
                            <ProductFinder
                                business_type="concierge"
                                @select="selectConcierge"
                            />
                        </div>
                        <ConciergesTable
                            class="mt-4"
                            :list="list"
                            @select="(id) => $router.push(`/concierges/${id}`)"
                        />

                        <CPagination
                            v-if="total > 1"
                            class="mt-4"
                            :active-page.sync="activePage"
                            :pages="total"
                            align="center"
                        />
                    </template>
                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="$router.push(`/concierges/create`)"
                    >Создать</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import ConciergesTable from '@/components/concierges/ConciergesTable';
    import ProductFinder from '@/components/ProductFinder';
    import { ITEMS_PER_PAGE } from '@/utils/views';

    export default {
        name: 'ConciergesList',

        components: {
            ConciergesTable,
            ProductFinder
        },

        data() {
            return {
                loading: true,
                list: [],
                total: 0,
                itemsPerPage: ITEMS_PER_PAGE,
            };
        },

        computed: {
            activePage: {
                get() {
                    return parseInt(this.$route.query.page) || 1;
                },
                async set(v) {
                    const query = { page: v };
                    this.$router.push({ query });
                },
            },
        },

        watch: {
            activePage: 'fetchList',
        },

        async created() {
            await Promise.all([this.fetchList()]);
            this.loading = false;
        },

        methods: {
            async fetchList() {
                const params = { page: this.activePage, pageSize: this.itemsPerPage };
                const response = await this.axios.get('/concierges', { params });
                this.list = response.data.results;
                this.total = Math.ceil(response.data.total / this.itemsPerPage);
            },
            selectConcierge(id) {
                this.$router.push('/concierges/' + id);
            }
        },
    };
</script>
